import { createAction, createAsyncFormAction } from 'utils';
import * as CONSTANTS from './constants.ts';
export var setVendorId = function (form) {
    return createAction(CONSTANTS.SET_VENDOR_ID, {}, form);
};
export var clearVendorId = function (form) {
    return createAction(CONSTANTS.CLEAR_VENDOR_ID, {}, form);
};
export var openConfirmationForRemove = function (form) {
    return createAction(CONSTANTS.OPEN_CONFIRMATION_MODAL_VENDOR_EDITING, {}, form);
};
export var readReportParameters = function (form, _a) {
    var dataID = _a.dataID;
    return createAction(CONSTANTS.READ_VENDOR_SALES_REPORT_PARAMETERS, { dataID: dataID }, form);
};
export var toggleReportsToShow = function (form, field, check) {
    return createAction(CONSTANTS.TOGGLE_REPORTS_TO_SHOW, { field: field, check: check }, form);
};
export var updateReportParameters = function (form, reportParameters) {
    return createAction(CONSTANTS.UPDATE_REPORT_PARAMETERS, { reportParameters: reportParameters }, form);
};
export var saveReportParameters = createAsyncFormAction(CONSTANTS.SAVE_VENDOR_SALES_REPORT_PARAMETERS);
export var closeVendorSalesReportParameters = createAsyncFormAction(CONSTANTS.CLOSE_VENDOR_SALES_REPORT_PARAMETERS);
